import { useState } from "react";
import { useNavigate } from "react-router-dom";

const facilities = ["Wi-Fi", "停车场", "游泳池", "健身房", "餐厅", "SPA", "儿童乐园", "24h前台"];
const images = [
  "https://readdy.ai/api/search-image?query=luxury%20resort%20hotel%20room%20interior%20ocean%20view%20modern%20elegant%20design%20large%20windows%20tropical%20sunshine%20professional%20hotel%20photography&width=375&height=220&seq=901&orientation=landscape",
  "https://readdy.ai/api/search-image?query=hotel%20infinity%20pool%20beachfront%20resort%20tropical%20blue%20ocean%20view%20palm%20trees%20luxury%20vacation%20photography&width=375&height=220&seq=902&orientation=landscape",
  "https://readdy.ai/api/search-image?query=hotel%20lobby%20luxury%20resort%20modern%20interior%20design%20high%20ceiling%20marble%20floor%20tropical%20plants%20warm%20lighting&width=375&height=220&seq=903&orientation=landscape",
];
const reviews = [
  { name: "王小明", avatar: "https://readdy.ai/api/search-image?query=chinese%20man%20casual%20avatar%20portrait%20profile%20photo%20clean%20background&width=36&height=36&seq=911&orientation=squarish", rating: 5, content: "酒店设施超棒，海景绝了！早餐品种丰富，服务也很周到，下次还来！", date: "2025-03-12" },
  { name: "张雨晴", avatar: "https://readdy.ai/api/search-image?query=chinese%20woman%20casual%20avatar%20portrait%20profile%20photo%20natural%20light&width=36&height=36&seq=912&orientation=squarish", rating: 5, content: "房间很大，床很舒服，就是位置稍微偏了点，不过酒店有接驳车，总体很满意。", date: "2025-02-28" },
];

export default function HotelDetailPage() {
  const navigate = useNavigate();
  const [imgIdx, setImgIdx] = useState(0);

  return (
    <div className="min-h-screen pb-[calc(env(safe-area-inset-bottom,0px)+96px)]" style={{ background: "#F8F9FC", fontFamily: "'Inter','SF Pro Text',sans-serif" }}>
      {/* Image carousel */}
      <div className="relative" style={{ height: 220 }}>
        <img src={images[imgIdx]} alt="hotel" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, transparent 40%)" }} />
        <button onClick={() => navigate(-1)} className="absolute left-5 w-9 h-9 flex items-center justify-center rounded-full cursor-pointer" style={{ top: "calc(env(safe-area-inset-top, 0px) + 48px)", background: "rgba(255,255,255,0.9)" }}>
          <i className="ri-arrow-left-line" style={{ fontSize: 20, color: "#374151" }} />
        </button>
        {/* Dots */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {images.map((_, i) => (
            <button key={i} onClick={() => setImgIdx(i)}
              className="rounded-full cursor-pointer transition-all"
              style={{ width: i === imgIdx ? 16 : 6, height: 6, background: i === imgIdx ? "#fff" : "rgba(255,255,255,0.5)" }} />
          ))}
        </div>
      </div>

      {/* Booked banner */}
      <div className="px-5 py-3 flex items-center gap-2" style={{ background: "#EFF6FF" }}>
        <i className="ri-checkbox-circle-fill" style={{ color: "#1E3A8A", fontSize: 18 }} />
        <span className="text-sm font-semibold" style={{ color: "#1E3A8A" }}>已预订</span>
        <span className="text-xs text-gray-500">· 入住日期：2025-05-01 至 2025-05-05</span>
      </div>

      <div className="px-5 py-4 space-y-4">
        {/* Basic info */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-lg font-bold text-gray-800 mb-1">三亚亚龙湾瑞吉度假酒店</div>
          <div className="flex items-center gap-1 text-xs text-gray-500 mb-2">
            <i className="ri-map-pin-line" style={{ fontSize: 13 }} />
            <span>三亚市亚龙湾国家旅游度假区</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-fill" style={{ color: "#F59E0B", fontSize: 14 }} />
            <span className="text-sm font-semibold text-gray-700">4.9</span>
            <span className="text-xs text-gray-400">(2341条评价)</span>
          </div>
        </div>

        {/* Room info */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-sm font-semibold text-gray-800 mb-3">房型信息</div>
          <div className="grid grid-cols-2 gap-3 text-xs text-gray-600">
            {[["房型", "海景豪华大床房"], ["床型", "1.8m大床"], ["早餐", "含双人早餐"], ["楼层", "高楼层"]].map(([k, v]) => (
              <div key={k} className="px-3 py-2 rounded-xl" style={{ background: "#F8F9FC" }}>
                <div className="text-gray-400 mb-0.5">{k}</div>
                <div className="font-medium text-gray-700">{v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Facilities */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-sm font-semibold text-gray-800 mb-3">酒店设施</div>
          <div className="flex flex-wrap gap-2">
            {facilities.map((f) => (
              <span key={f} className="text-xs px-3 py-1.5 rounded-full" style={{ background: "#F3F4F6", color: "#374151" }}>{f}</span>
            ))}
          </div>
        </div>

        {/* Reviews */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="flex items-center justify-between mb-3">
            <div className="text-sm font-semibold text-gray-800">用户评价</div>
            <span className="text-xs cursor-pointer" style={{ color: "#1E3A8A" }}>查看全部 →</span>
          </div>
          <div className="space-y-4">
            {reviews.map((r) => (
              <div key={r.name} className="flex gap-3">
                <img src={r.avatar} alt={r.name} className="w-9 h-9 rounded-full object-cover object-top flex-shrink-0" />
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-700">{r.name}</span>
                    <span className="text-xs text-gray-400">{r.date}</span>
                  </div>
                  <div className="flex my-1">
                    {Array(r.rating).fill(0).map((_, i) => <i key={i} className="ri-star-fill" style={{ color: "#F59E0B", fontSize: 12 }} />)}
                  </div>
                  <div className="text-xs text-gray-500 leading-relaxed">{r.content}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Cancel policy */}
        <div className="bg-white rounded-2xl p-4" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.04)" }}>
          <div className="text-sm font-semibold text-gray-800 mb-2">取消政策</div>
          <div className="text-xs text-gray-500 leading-relaxed">入住日期前7天可免费取消；前3天取消扣除1晚房费；入住当天及之后不可退款。</div>
        </div>
      </div>

      {/* Bottom button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white px-5 pt-4" style={{ boxShadow: "0 -4px 16px rgba(0,0,0,0.06)", paddingTop: "16px", paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))" }}>
        <button onClick={() => navigate(-1)}
          className="w-full flex items-center justify-center gap-2 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer transition-all active:scale-95"
          style={{ height: 48, background: "#F3F4F6", color: "#374151" }}>
          <i className="ri-arrow-left-line" />
          返回订单
        </button>
      </div>
    </div>
  );
}
